import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
// import Icon from "@mdi/react";

// import chiTietDanhGia from "./app-assets/images/tabler_message-star1.png"
import { ModalChiTiet } from "./ModalChiTiet";

export const BtnChiTietDanhGia = ({ item }) => {
  const [isModalVisible, setModalVisible] = useState(false);
  const toggleModal = () => {
    setModalVisible(!isModalVisible);
  };
  return (
    <>
      <a href={() => false} class="iconTable-Main" onClick={toggleModal}>
        <img
          src="/app-assets/images/tabler_message-star1.png"
          title="Chi tiết đánh giá"
          alt=""
          style={{ width: "20px" }}
        />
        {/* <i class="fas fa-info-circle"></i> */}
      </a>
      <ModalChiTiet
        isModalVisible={isModalVisible}
        toggleModal={toggleModal}
        TicketId={item.Id}
      />
    </>
  );
};
